<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000" persistent scrollable>

      <v-card :loading="isLoading" :disabled="isLoading">

        <v-card-title>
          {{ title }}
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">
          <v-tabs color="gifty" centered>
            <v-tab>Information & affectation</v-tab>
            <v-tab >Cadeaux</v-tab>

            <v-tab-item class="px-3 py-3">

              <!-- TYPE -->
              <v-radio-group v-model="form.type"
                             label="Type *"
                             row
                             :error-messages="formErrors.type">
                <v-radio label="Spin to win" value="spintowin"/>
                <v-radio label="Memory game" value="memory_game"/>
              </v-radio-group>

              <v-text-field v-model="form.description"
                            outlined
                            dense
                            :error-messages="formErrors.description"
                            label="Désignation *"
              />

              <v-row>

                <v-col cols="6">
                  <v-menu v-model="dateMenu1" :close-on-content-click="false" :nudge-right="40"
                          min-width="auto"
                          offset-y transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.start_date"
                                    label="Début *"
                                    hide-details="auto"
                                    dense
                                    outlined
                                    prepend-inner-icon="mdi-calendar-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_date"
                                   :min="form.start_date"
                                   @input="dateMenu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="6">
                  <v-menu v-model="dateMenu2" :close-on-content-click="false" :nudge-right="40"
                          min-width="auto"
                          offset-y transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.end_date"
                                    label="Fin *"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    prepend-inner-icon="mdi-calendar-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_date"
                                   :min="form.end_date"
                                   @input="dateMenu2 = false"></v-date-picker>
                  </v-menu>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="form.border_color"
                                outlined
                                dense
                                hide-details="auto"
                                :error-messages="formErrors.border_color"
                                label="Border color *"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.fill_color"
                                outlined
                                hide-details="auto"
                                dense
                                :error-messages="formErrors.fill_color"
                                label="Fill color *"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="form.max_spins_per_day"
                                outlined
                                dense
                                :error-messages="formErrors.max_spins_per_day"
                                label="Nombre de parties/jour *"
                                persistent-hint
                                hint="Combien de fois un utilisateur peut jouer par jour"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.max_total_spins_per_user"
                                outlined
                                dense
                                :error-messages="formErrors.max_total_spins_per_user"
                                label="Nombre total de parties *"
                                persistent-hint
                                hint="Combien de fois un utilisateur peut jouer en tout"
                  />
                </v-col>
              </v-row>

              <!-- LOGO -->
              <v-file-input :value="form.logo"
                            @change="uploadLogo($event)"
                            :error-messages="formErrors.logo"
                            accept="image/*"
                            outlined
                            dense
                            label="Logo central *"/>
              <v-img v-if="form.logo_preview"
                     :src="form.logo_preview"
                     height="80"
                     width="80"
                     contain
                     class="mb-4 rounded"/>

              <!-- MEMORY GAME IMAGES (6) -->
              <div v-if="form.type === 'memory_game'" class="mb-6">
                <div class="v-label mb-2">Images du jeu (6 images) *</div>
                <v-row>
                  <v-col v-for="(img, i) in form.memory_images" :key="i" cols="12" md="4">
                    <v-file-input :value="img.file"
                                  accept="image/*"
                                  outlined
                                  dense
                                  hide-details="auto"
                                  :label="`Image ${i + 1} *`"
                                  :error-messages="formErrors[`memory_images.${i}`]"
                                  @change="uploadMemoryImage($event, i)"/>
                    <v-img v-if="img.preview"
                           :src="img.preview"
                           height="80"
                           contain
                           class="mt-2 rounded"/>
                  </v-col>
                </v-row>
                <span v-if="formErrors.memory_images" class="text-danger">
                  {{ formErrors.memory_images[0] }}
                </span>
              </div>

              <v-text-field v-model="form.order"
                            outlined
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.order"
                            label="Order *"
              />

              <v-switch v-model="form.is_default"
                        hide-details
                        label="Visible pour tout le monde"></v-switch>

              <v-radio-group v-if="!form.is_default"
                             v-model="form.users_assignment_type"
                             label="Affectation *" row>
                <v-radio label="Choisir" value="specify"/>
                <v-radio label="Exclure" value="exclude"/>
              </v-radio-group>

              <div class="d-flex justify-space-between">
                <div>
                  <v-btn v-if="!form.is_default"
                         class="secondary"
                         depressed
                         @click="selectUsers">
                    Affecter des Utilisateurs ({{ form.userIds?.length }})
                  </v-btn>
                  <span v-if="formErrors && formErrors.userIds" class="text-danger">
                    {{ formErrors.userIds[0] }}
                  </span>
                </div>
              </div>
            </v-tab-item>

            <v-tab-item class="px-3 py-3">

              <v-alert type="info" text>
                <p>
                  <strong>Qté totale :</strong>
                  Le cadeau ne peut être gagné qu’un nombre limité de fois au total (ex. 100 fois).
                </p>

                <p>
                  <strong>Qté/utilisateur :</strong>
                  Chaque utilisateur ne peut gagner ce cadeau qu’une seule fois.
                </p>

                <p>
                  <strong>Qté/jour/utilisateur :</strong>
                  Un utilisateur ne peut gagner ce cadeau qu’une fois par jour.
                </p>

                <p>
                  <strong>Qté/jour globale :</strong>
                  Le cadeau ne peut être gagné qu’un nombre limité de fois par jour pour l’ensemble des utilisateurs
                  (ex. 10 fois).
                </p>
              </v-alert>

              <v-simple-table class="table-border rounded-lg mt-3 t">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th></th>
                    <th>Nom</th>
                    <th>Image</th>
                    <th>Couleur</th>
                    <th>Pourcentage</th>
                    <th>Type</th>
                    <th>Montant</th>
                    <th class="text-no-wrap">Qté totale</th>
                    <th class="text-no-wrap">Qté/utilisateur</th>
                    <th class="text-no-wrap">Qté/jour/utilisateur</th>
                    <th class="text-no-wrap">Qté/jour globale</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- unique key: deleting a row no longer shifts file inputs / previews onto the wrong row -->
                  <tr v-for="(gift, i) in form.gifts" :key="gift._key">
                    <td>
                      <v-switch color="success"
                                class="pa-0 ma-0"
                                label="Disponibilité"
                                v-model="gift.is_active" hide-details="auto"
                                dense/>
                    </td>

                    <td>
                      <v-text-field v-model="gift.name" hide-details="auto" dense placeholder="Nom *"/>
                    </td>
                    <td>
                      <v-file-input :value="gift.image"
                                    @change="uploadFile($event,i)"
                                    accept="image/*"
                                    hide-details="auto"
                                    dense
                                    placeholder="Image *"/>
                      <v-img v-if="gift.preview"
                             :src="gift.preview"
                             height="40"
                             width="40"
                             contain
                             class="mt-1 rounded"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.color"
                                    hide-details="auto"
                                    dense
                                    placeholder="Couleur"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.percentage" hide-details="auto" dense placeholder="%" type="number"/>
                    </td>
                    <td>

                      <v-select
                          v-model="gift.type"
                          :items="['digital', 'physical','none']"
                          hide-details="auto"
                          dense
                          placeholder="Type *"
                      />

                      <v-select v-if="gift.type === 'digital'"
                                v-model="gift.digital_amount_type"
                                item-text="name"
                                item-value="value"
                                :items="[
                                    {name : 'Solde globale',value:'unique_solde'},
                                    {name:'Solde carte gifty',value:'card_solde'},
                                ]"
                                dense
                                :hide-details="gift.digital_amount_type === 'card_solde'"
                                placeholder="Type de montant *"
                      />

                      <v-select v-if="gift.digital_amount_type === 'card_solde'"
                                v-model="gift.account_card_template_id"
                                :items="templates"
                                item-text="name"
                                item-value="id"
                                dense
                                placeholder="Modèle de carte *"
                      />

                    </td>
                    <td>
                      <v-text-field :disabled="gift.type !== 'digital'"
                                    v-model="gift.digital_amount" hide-details="auto" dense placeholder="Montant *"
                                    type="number"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.quantity_total" hide-details="auto" dense placeholder="Qté totale *"
                                    type="number"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.quantity_per_user" hide-details="auto" dense
                                    placeholder="Qté/utilisateur *" type="number"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.max_daily_win_per_user" hide-details="auto" dense
                                    placeholder="Qté/jour/utilisateur *" type="number"/>
                    </td>
                    <td>
                      <v-text-field v-model="gift.max_daily_global_wins" hide-details="auto" dense
                                    placeholder="Qté/jour globale *" type="number"/>
                    </td>
                    <td>
                      <div class="d-flex">
                        <v-btn
                            v-if="form.gifts.length > 1"
                            icon
                            color="gifty"
                            @click="removeGift(i)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>

                        <v-btn
                            v-if="i === form.gifts.length - 1"
                            icon
                            color="gifty"
                            @click="addGift"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>


            </v-tab-item>
          </v-tabs>


        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="btnLoading"
                 color="gifty"
                 dark
                 depressed
                 @click="saveData">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SelectUsers ref="selectUsers" @selected="setUsers($event)"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import SelectUsers from "./SelectUsers.vue";

const STORAGE_PREFIX = "/";

let giftKey = 0;

export default {
  components: {
    SelectUsers
  },
  props: ['boostings'],
  data() {
    return {
      id: null,
      tab: null,
      title: null,
      btnLoading: false,
      isLoading: false,
      dialog: false,
      selectedUsers: [],
      formErrors: {},
      templates: [],

      form: {
        type: 'spintowin',
        logo: null,
        logo_preview: "",
        memory_images: [],
        userIds: [],
        gifts: []
      },

      dateMenu1: false,
      dateMenu2: false
    };
  },
  created() {
    this.getCardsTemplates()
  },
  methods: {
    getCardsTemplates() {
      HTTP.get('/v1/account-cards/templates').then(res => {
        this.templates = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },

    /** Build a displayable URL from what the API returned (full URL or relative path) */
    fileUrl(path) {
      if (!path) return "";
      if (/^(https?:|blob:|data:)/.test(path)) return path;

      const base = (
          process.env.VUE_APP_FILE_URL ||
          (HTTP.defaults.baseURL || "").replace(/\/api.*$/, "")
      ).replace(/\/$/, "");

      return `${base}${STORAGE_PREFIX}${String(path).replace(/^\/+/, "")}`;
    },

    emptyMemoryImages() {
      return Array.from({length: 6}, () => ({file: null, existing: "", preview: ""}))
    },
    newGift() {
      return {
        _key: ++giftKey,
        name: "",
        image: null,
        existing_image: "",
        preview: "",
        percentage: "",
        type: 'digital',
        digital_amount_type: 'unique_solde',
        account_card_template_id: "",
        color: "#d60c56",
        digital_amount: "",
        quantity_total: "",
        quantity_per_user: "",
        max_daily_win_per_user: "",
        max_daily_global_wins: "",
        is_active: true,
      }
    },

    uploadLogo(file) {
      this.form.logo = file || null
      this.form.logo_preview = file
          ? URL.createObjectURL(file)
          : this.fileUrl(this.form.existing_logo)
    },
    uploadMemoryImage(file, index) {
      const img = this.form.memory_images[index]
      img.file = file || null
      img.preview = file ? URL.createObjectURL(file) : this.fileUrl(img.existing)
    },
    uploadFile(file, index) {
      const gift = this.form.gifts[index]
      gift.image = file || null
      gift.preview = file ? URL.createObjectURL(file) : this.fileUrl(gift.existing_image)
    },

    addGift() {
      this.form.gifts.push(this.newGift())
    },
    removeGift(index) {
      this.form.gifts.splice(index, 1)
    },

    setUsers(e) {
      this.form.userIds = e.users;
      this.form.filter = e.filter;
    },
    selectUsers() {
      this.$refs.selectUsers.setUsers(
          this.selectedUsers,
          this.form.userIds,
          this.form.filter
      );
      this.$refs.selectUsers.open();
    },

    open() {
      this.title = "Ajouter un jeu"
      this.id = null;
      this.formErrors = {};
      this.selectedUsers = [];
      this.form = {
        type: 'spintowin',
        logo: null,
        existing_logo: "",
        logo_preview: "",
        memory_images: this.emptyMemoryImages(),
        description: "",
        start_date: "",
        end_date: "",
        border_color: "#d60c56",
        fill_color: "#f14a86",
        order: 1,
        max_spins_per_day: "",
        max_total_spins_per_user: "",
        userIds: [],
        is_default: 1,
        filter: "",
        users_assignment_type: 'specify',
        gifts: [this.newGift()],
      }
      this.dialog = true;
    },

    edit(item) {
      this.title = "Modifier un jeu"
      this.id = item.id;
      this.formErrors = {};
      this.selectedUsers = [];

      // item.memory_images = array of image urls/paths coming from the API
      const existing = item.memory_images ?? [];

      // Rebuild the WHOLE form so nothing from a previous edit/add stays behind
      this.form = {
        type: item.type ?? 'spintowin',
        logo: null,
        existing_logo: item.logo ?? "",
        logo_preview: this.fileUrl(item.logo),
        memory_images: this.emptyMemoryImages().map((slot, i) => ({
          ...slot,
          existing: existing[i] ?? "",
          preview: this.fileUrl(existing[i]),
        })),
        description: item.description,
        start_date: item.start_date,
        end_date: item.end_date,
        border_color: item.border_color,
        fill_color: item.fill_color,
        order: item.order,
        max_spins_per_day: item.max_spins_per_day,
        max_total_spins_per_user: item.max_total_spins_per_user,
        userIds: [],
        is_default: item.is_default,
        filter: item.filter
            ? (typeof item.filter === 'object' ? JSON.stringify(item.filter) : item.filter)
            : "",
        users_assignment_type: item.users_assignment_type,
        gifts: (item.gifts ?? []).map(el => ({
          _key: ++giftKey,
          id: el.id,
          name: el.name,
          image: null,
          existing_image: el.image ?? "",
          preview: this.fileUrl(el.image),
          percentage: el.percentage,
          type: el.type,
          digital_amount_type: el.digital_amount_type,
          account_card_template_id: el.account_card_template_id,
          color: el.color,
          digital_amount: el.digital_amount,
          quantity_total: el.quantity_total,
          quantity_per_user: el.quantity_per_user,
          max_daily_win_per_user: el.max_daily_win_per_user,
          max_daily_global_wins: el.max_daily_global_wins,
          is_active: el.is_active
        })),
      };

      if (!this.form.gifts.length) {
        this.form.gifts.push(this.newGift());
      }

      this.dialog = true;
      this.show(item.id);
    },

    close() {
      this.formErrors = {};
      this.dialog = false;
    },

    show(id) {
      this.isLoading = true;
      HTTP.get("/v1/spintowins/show/" + id)
          .then((res) => {
            this.isLoading = false;

            const data = res.data.data;

            this.form.userIds = data.users.map(u => u.id);
            this.selectedUsers = data.users;
          }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },

    saveData() {
      this.formErrors = {};
      this.btnLoading = true;

      const isMemory = this.form.type === 'memory_game';
      const formData = new FormData();

      formData.append("id", this.id ?? "");
      formData.append("type", this.form.type);
      formData.append("description", this.form.description ?? "");
      formData.append("start_date", this.form.start_date ?? "");
      formData.append("end_date", this.form.end_date ?? "");
      formData.append("border_color", this.form.border_color ?? "");
      formData.append("fill_color", this.form.fill_color ?? "");
      formData.append("max_spins_per_day", this.form.max_spins_per_day ?? "");
      formData.append("max_total_spins_per_user", this.form.max_total_spins_per_user ?? "");
      formData.append("order", this.form.order ?? "");
      formData.append("is_default", this.form.is_default ? 1 : 0);
      formData.append("filter", this.form.filter ?? "");
      formData.append("users_assignment_type", this.form.users_assignment_type ?? "");

      // Only send the logo when a NEW file was picked (otherwise the backend keeps the old one)
      if (this.form.logo instanceof File) {
        formData.append("logo", this.form.logo);
      }

      if (isMemory) {
        this.form.memory_images.forEach((img, index) => {
          if (img.file instanceof File) formData.append(`memory_images[${index}]`, img.file);
          formData.append(`existing_memory_images[${index}]`, img.existing ?? "");
        });
      }

      this.form.userIds.forEach((id, index) => {
        formData.append(`userIds[${index}]`, id);
      });

        this.form.gifts.forEach((gift, index) => {
          formData.append(`gifts[${index}][id]`, gift.id ?? "");
          formData.append(`gifts[${index}][name]`, gift.name ?? "");
          if (gift.image instanceof File) {
            formData.append(`gifts[${index}][image]`, gift.image);
          }
          formData.append(`gifts[${index}][existing_image]`, gift.existing_image ?? "");
          formData.append(`gifts[${index}][color]`, gift.color ?? "");
          formData.append(`gifts[${index}][percentage]`, gift.percentage ?? "");
          formData.append(`gifts[${index}][type]`, gift.type ?? "");
          formData.append(`gifts[${index}][digital_amount_type]`, gift.digital_amount_type ?? "");
          formData.append(`gifts[${index}][account_card_template_id]`, gift.account_card_template_id ?? "");
          formData.append(`gifts[${index}][digital_amount]`, gift.digital_amount ?? "");
          formData.append(`gifts[${index}][quantity_total]`, gift.quantity_total ?? "");
          formData.append(`gifts[${index}][quantity_per_user]`, gift.quantity_per_user ?? "");
          formData.append(`gifts[${index}][max_daily_win_per_user]`, gift.max_daily_win_per_user ?? "");
          formData.append(`gifts[${index}][max_daily_global_wins]`, gift.max_daily_global_wins ?? "");
          formData.append(`gifts[${index}][is_active]`, gift.is_active ? 1 : 0);
        });

      let url = this.id ? "/v1/spintowins/update" : "/v1/spintowins/store"

      HTTP.post(url, formData)
          .then(() => {
            this.$successMessage = this.id
                ? "Cet élément a été modifié avec succès"
                : "Cet élément a été ajouté avec succès";
            this.btnLoading = false;
            this.close();
            this.$emit("refresh");
          })
          .catch((err) => {
            this.btnLoading = false;
            this.formErrors = err.response?.data?.errors ?? {};
          });
    },
  },
};
</script>

<style scoped>
.t td,
.t th {
  min-width: 180px;
}
</style>